import { loadStripe } from "@stripe/stripe-js";

export type Plan = "standard_monthly" | "none";
export const supportEmail = "support@springblock.dev";
export const stripeLoader = loadStripe(import.meta.env.VITE_STRIPE_PUBLISH_KEY);
